<div class="yf-row ml-8" [ngClass]="mayWrap">
  <div *ngFor="let connector of $connectors(); trackBy: connectorTrackBy">
    <yf-station-connector [$connector]="connector"></yf-station-connector>
  </div>
</div>